import React from 'react';
import PricingPageContainer from './pricing.styles';
import PricingPlan from './../../components/pricing-plan/pricing-plan.component';
import MainHeading from '../../components/main-heading/main-heading.component';
import Container from '../../components/container/container.component';
const PricingPage = () => {
    return (
        <PricingPageContainer id="Pricing">
            <Container>
                <div className="container">
                    <MainHeading title="Pricing" />
                    <div className="plans">
                        <PricingPlan
                            name="Basic"
                            price="19"
                            features={[
                                { id: 1, feature: 'Feature No 1' },
                                { id: 2, feature: 'Extra Feature' },
                                { id: 3, feature: 'Extra Feature No 2' },
                                { id: 4, feature: 'Feature' },
                            ]}
                        />
                        <PricingPlan
                            name="Premium"
                            price="29"
                            features={[
                                { id: 5, feature: 'Feature No 1' },
                                { id: 6, feature: 'Extra Feature' },
                                { id: 7, feature: 'Extra Feature No 2' },
                                { id: 8, feature: 'Feature' },
                            ]}
                        />
                        <PricingPlan
                            name="Pro"
                            price="39"
                            features={[
                                { id: 9, feature: 'Feature No 1' },
                                { id: 10, feature: 'Extra Feature' },
                                { id: 11, feature: 'Extra Feature No 2' },
                                { id: 12, feature: 'Feature' },
                            ]}
                        />
                        <PricingPlan
                            name="Platinum"
                            price="49"
                            features={[
                                { id: 13, feature: 'Feature No 1' },
                                { id: 14, feature: 'Extra Feature' },
                                { id: 15, feature: 'Extra Feature No 2' },
                                { id: 16, feature: 'Feature' },
                            ]}
                        />
                    </div>
                    <p className="contact-text">
                        Contact us if you have special request
                    </p>
                    <a href="test" className="contact-link">
                        Contact Us
                    </a>
                </div>
            </Container>
        </PricingPageContainer>
    );
};
export default PricingPage;
